import * as React from 'react';
import { SharingSocials } from '../../components/SharingSocials';
import { selectFilters } from '../../../common/selectors/filters';
import { useSelector } from 'react-redux';
import { useApplicationContext } from '../../../common/utils/applicationContext';
import { getRatingPosCount } from '../../../common/utils/getRatingPosCount';
import { createDataForLinks } from './helpers';
import { useDeviceType } from '@cian/ui-kit';

export const SharingSocialContainer: React.FC = () => {
  const { region, type, date } = useSelector(selectFilters);

  const deviceIsPhone = useDeviceType() === 'phone';

  const [posCount, setPosCount] = React.useState<number>(10);

  const { config } = useApplicationContext();

  const ratingPosCount = getRatingPosCount(config, region.slug, type);

  React.useEffect(() => {
    setPosCount(ratingPosCount);
  }, [ratingPosCount]);

  const socials = createDataForLinks(posCount, date);

  return <SharingSocials socialsData={socials} isPhone={deviceIsPhone} />;
};
